import React, { useEffect, useState } from 'react';

import { DialogUI, InputUI } from '../Interface';
import { Box, Typography } from '@mui/material';
import serviceCoreService from '../../service/serviceCore.service';

const highlightMatches = (text, query) => {
  const str = String(text ?? '');
  const rawQ = String(query || '').trim();
  if (!rawQ) return str;

  const tokens = rawQ.split(/\s+/).filter(Boolean);
  if (!tokens.length) return str;

  const lower = str.toLowerCase();
  let bestIndex = -1;
  let bestToken = '';

  tokens.forEach((t) => {
    const tl = t.toLowerCase();
    const idx = lower.indexOf(tl);
    if (idx !== -1 && (bestIndex === -1 || idx < bestIndex)) {
      bestIndex = idx;
      bestToken = t;
    }
  });

  if (bestIndex === -1) return str;

  const before = str.slice(0, bestIndex);
  const matchOriginal = str.slice(bestIndex, bestIndex + bestToken.length);
  const after = str.slice(bestIndex + bestToken.length);

  return [
    before,
    <span key="hl-0" style={{ color: '#0d47a1' }}>
      {matchOriginal}
    </span>,
    after,
  ];
};

const SearchDialog = ({ open, handleClose, searchQuery, setSelectedService, onSearchChange }) => {
  const [searchResults, setSearchResults] = useState([]);

  const getDialogTasks = () => {
    if (!searchQuery) {
      setSearchResults([]);
      return;
    }

    serviceCoreService.searchServices({ query: searchQuery }).then((data) => {
      setSearchResults(data || []);
    });
  };

  useEffect(() => {
    getDialogTasks();
  }, [searchQuery]);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={'Szerviz munka kiválasztása'}
      sx={{
        '& .MuiDialog-container': { alignItems: 'flex-start' },
        '& .MuiPaper-root': { width: '100%', maxWidth: '800px', height: '70vh' },
        '& .MuiDialogContent-root': { overflowY: 'auto', maxHeight: '100%' },
        marginTop: '40px',
      }}
    >
      <Box my={2}>
        <InputUI
          type="search"
          placeholder="Keresés..."
          value={searchQuery}
          onChange={(e) => onSearchChange?.(e.target.value)}
          autoFocus
          fullWidth
          size="small"
          sx={{ flex: 1 }}
        />
      </Box>

      {searchResults?.length === 0 ? (
        <Box>Nincs találat.</Box>
      ) : (
        <Box component="section" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {searchResults?.map((evt, idx) => {
            const { id, workingNumber, project } = evt;

            return (
              <Box
                key={id}
                onClick={() => {
                  if (!Number.isNaN(id)) setSelectedService(evt);
                  handleClose();
                }}
                sx={{
                  px: 1.5,
                  py: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  cursor: 'pointer',
                  '&:hover': { bgcolor: 'action.hover' },
                }}
              >
                <Typography variant="subtitle1" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
                  {highlightMatches([workingNumber, `#${id}`].filter(Boolean).join(' '), searchQuery)}
                </Typography>

                <Typography
                  variant="caption"
                  color="text.secondary"
                  component="div"
                  sx={{ display: 'block', mt: 0.25 }}
                >
                  <Box component="span" sx={{ fontWeight: 600 }}>
                    Projekt:
                  </Box>{' '}
                  {highlightMatches(project?.projectName ?? '', searchQuery)}
                </Typography>

                <Typography
                  variant="caption"
                  color="text.secondary"
                  component="div"
                  sx={{ display: 'block', mt: 0.25 }}
                >
                  <Box component="span" sx={{ fontWeight: 600 }}>
                    Projekt rendelési szám:
                  </Box>{' '}
                  {highlightMatches(project?.orderNumber ?? '', searchQuery)}
                </Typography>
              </Box>
            );
          })}
        </Box>
      )}
    </DialogUI>
  );
};

export default SearchDialog;
